import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { DialogData } from 'src/app/interfaces/mat.interface';

@Component({
  selector: 'app-dialog',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  encapsulation: ViewEncapsulation.None,
})
export class DialogComponent {
  public data: DialogData = inject(MAT_DIALOG_DATA);  
}
